import { clipUtils } from './common'

/**
 * @dtsModule max.clip
 * @dtsNamespace clip
 * @dtsDesc clip Clipboard
 */
export const clip = {
  /**
   * @dtsExport
   * Set clipboard information
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.clip.set&lang=%{locale}%)
   */
  set(content: string): Promise<true> {
    return new Promise((resolve, reject) => {
      clipUtils.set(content, () => {
        resolve(true)
      }, (msg: string | undefined) => {
        reject(msg)
      })
    })
  },
  /**
   * @dtsExport
   * Get clipboard information
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.clip.get&lang=%{locale}%)
   */
  get(): Promise<string> {
    return new Promise((resolve, reject) => {
      clipUtils.get((res) => {
        resolve(res || "")
      }, (msg: string | undefined) => {
        reject(msg)
      })
    })
  },
  /**
   * @dtsExport
   * Clear clipboard information
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.clip.clear&lang=%{locale}%)
   */
  clear(): Promise<true | string> {
    return new Promise((resolve, reject) => {
      clipUtils.clear(() => {
        resolve(true)
      }, (msg: string | undefined) => {
        reject(msg)
      })
    })
  },

}

